module.exports = "<select class=\"multiple-select\" ng-model=\"$ctrl.localSelectedValues\" multiple style=\"width: 100%\" ng-required=\"$ctrl.required\"  ng-change=\"$ctrl.onLocalSelect()\">\r\n        <option ng-repeat=\"option in $ctrl.options\" ng-value=\"option\">{{option[$ctrl.labelKey]}}</option>\r\n</select>"


//////////////////
// WEBPACK FOOTER
// ../widgets/multiple-select/multiple-select.html
// module id = 755
// module chunks = 0